<app-marine-insurance-card [cardTitle]="'INSURED_VALUE_AND_COMMODITY'" [isCanEdit]="true" (edit)="edit.emit()">
  <ng-container body>
    <div class="marine-insurance-commodities-view-data">
      <div class="row mb-1">
        <div class="col-5 col-md-3 marine-insurance-commodities-view-data-label">
          {{ "COMMODITIES_CATEGORY" | translate }}
        </div>
        <div class="col-7 col-md-9 marine-insurance-commodities-view-data-value">
          {{
            !!marineInsurance?.updatedInsuredValue?.commodity
              ? marineInsurance?.updatedInsuredValue?.commodity?.name
              : marineInsurance?.insuredValue?.commodity?.name
          }}
        </div>
      </div>

      <div class="row mb-1" *ngIf="isVehiclesCommodity && !!manufactureDate">
        <div class="col-5 col-md-3 marine-insurance-commodities-view-data-label">
          {{ "LABELS.MANUFACTURE_YEAR" | translate }}
        </div>
        <div class="col-7 col-md-9 marine-insurance-commodities-view-data-value">
          {{ manufactureDate | customDateByUtc : "YYYY" }}
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-5 col-md-3 marine-insurance-commodities-view-data-label">
          {{ "INSURED_VALUE" | translate }}
        </div>
        <div class="col-7 col-md-9 marine-insurance-commodities-view-data-value">
          {{
            (!!marineInsurance?.updatedInsuredValue?.insuredAmount
              ? marineInsurance?.updatedInsuredValue?.insuredAmount
              : marineInsurance?.insuredValue?.insuredAmount
            ) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
          }}
        </div>
      </div>

      <div class="row mb-1" *ngIf="!!marineInsurance?.shippingDate">
        <div class="col-5 col-md-3 marine-insurance-commodities-view-data-label">
          {{ "LABELS.DESCRIPTION" | translate }}
        </div>
        <div class="col-7 col-md-9 marine-insurance-commodities-view-data-value">
          {{
            !!marineInsurance?.updatedInsuredValue?.goodsTypeDescription
              ? marineInsurance?.updatedInsuredValue?.goodsTypeDescription
              : marineInsurance?.insuredValue?.goodsTypeDescription
          }}
        </div>
      </div>
    </div>
  </ng-container>
</app-marine-insurance-card>
